import * as React from "react";
import { User, Category } from "../api/classes";
import { Avatar, Typography, Select, MenuItem } from "@material-ui/core";
import { connect } from "react-redux";
import { GlobalState } from "../store";
import { RouteComponentProps } from "react-router-dom";
import * as actions from "../store/cases/actions";
import FolderIcon from "@material-ui/icons/Folder";
import * as constants from "../api/constants";
interface Props {
  value: string;
  onChange?: () => void;
  onSelect: (id: string) => void;
  readOnly?: boolean;
  style?: React.CSSProperties;
}
export const statusItems = [
  {
    id: constants.STATUS_PENDING,
    label: "Pending"
  },
  {
    id: constants.STATUS_IN_PROGRESS,
    label: "In Progress"
  },
  {
    id: constants.STATUS_NO_ANALYSIS,
    label: "No Analysis"
  },
  {
    id: constants.STATUS_VERIFIED,
    label: "Verified"
  }
];
export default class StatusSelect extends React.Component<Props> {
  handleChange = e => {
    this.props.onSelect(e.target.value);
  };
  render() {
    const { value } = this.props;
    if (this.props.readOnly) {
      return this.renderReadOnly();
    }
    return (
      <div
        style={{
          ...this.props.style,
          position: "relative"
        }}
      >
        <Select
          disableUnderline
          style={{
            alignSelf: "flex-start",
            marginLeft: 16,
            backgroundColor: constants.statusColors[value],
            paddingLeft: 16,
            color: "white"
          }}
          value={value}
          onChange={this.handleChange}
          inputProps={{
            name: "age",
            id: "age-simple"
          }}
        >
          {statusItems.map(u => {
            return (
              <MenuItem key={u.id} value={u.id}>
                {u.label}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }
  renderReadOnly() {
    const { value } = this.props;
    const status = statusItems.find(i => i.id === value);
    return (
      <div
        style={{
          ...this.props.style,
          position: "relative"
        }}
      >
        <Typography
          style={{
            alignSelf: "flex-start",
            marginLeft: 16,
            backgroundColor: constants.statusColors[value],
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 4,
            paddingBottom: 4,
            color: "white",
            fontSize: 17
          }}
          variant="body2"
        >
          {status && status.label}
        </Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/statusSelect.tsx